import { Col, Tooltip } from "antd";
import { ReactNode } from "react";

export function VehicleSpecCol({ children }: { children: ReactNode }) {
  return (
    <Col flex={"0 0 140px"} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2 }}>
      {children}
    </Col>
  )
}

export function TinySpace({ children, tooltip }: { children: ReactNode, tooltip: string }) {
  return (
    <Tooltip title={tooltip}>
      <div style={{ display: "flex", gap: 8 }}>
        {children}
      </div>
    </Tooltip>
  )
}

export function Value({ value, suffix, prefix }: { value: ReactNode, suffix?: ReactNode, prefix?: ReactNode }) {
  const isEmpty = !value || value === '-';
  return isEmpty ? null : (
    <span style={{ fontWeight: 400, wordBreak: "keep-all" }}>{prefix ? prefix : null} {value} {suffix ? suffix : null}</span>
  )
}
